export class SKProductDiscount {
    constructor(price, localeIdentifier, numberOfPeriods, subscriptionPeriod, paymentMode, identifier, type, currencySymbol) {
        this.price = price;
        this.localeIdentifier = localeIdentifier;
        this.numberOfPeriods = numberOfPeriods;
        this.subscriptionPeriod = subscriptionPeriod;
        this.paymentMode = paymentMode;
        this.identifier = identifier;
        this.type = type;
        this.currencySymbol = currencySymbol;
    }
}
//# sourceMappingURL=SKProductDiscount.js.map